import React from "react";
import classNames from "classnames";
import { Container } from "components/shared";
import { APP_NAME } from "constants/app.constant";
import { PAGE_CONTAINER_GUTTER_X } from "constants/theme.constant";
import { Link } from "react-router-dom";

const FooterContent = () => {
  return (
    <div className="flex items-center justify-between flex-auto w-full">
      <span className="flex gap-4 items-center">
        <p>
          Copyright &copy; {`${new Date().getFullYear()}`}{" "}
          <span className="font-semibold text-primary">{`${APP_NAME}`}</span>
        </p>
        <p className="text-gray-500">All rights reserved.</p>
      </span>
      <div className="">
        <Link className="text-gray" to="/terms-and-conditions">
          Term & Conditions
        </Link>
        <span className="mx-2 text-muted"> | </span>
        <Link className="text-gray" to="/privacy-policy">
          Privacy & Policy
        </Link>
      </div>
    </div>
  );
};

export default function Footer({ pageContainerType }) {
  return (
    <footer
      className={classNames(
        `footer flex flex-auto items-center h-16 ${PAGE_CONTAINER_GUTTER_X}`
      )}
    >
      {pageContainerType === "contained" ? (
        <Container>
          <FooterContent />
        </Container>
      ) : (
        <FooterContent />
      )}
    </footer>
  );
}
